/**
 *  Loại phương án phân bổ
 */
export default {
  NotDelivered: 1, // Chưa giao
  Delivered: 2, // Đã giao
  CancelDelivered: 3, // Đã thu hồi
  PartiallyDelivered: 4, // Đã giao một số đơn vị
  Delivering: 5, // Đang giao
};
